import { render, staticRenderFns } from "./web-app.vue?vue&type=template&id=5036da59&scoped=true"
import script from "./web-app.vue?vue&type=script&lang=js"
export * from "./web-app.vue?vue&type=script&lang=js"
import style0 from "./main.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./web-app.vue?vue&type=style&index=1&id=5036da59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5036da59",
  null
  
)

export default component.exports